import type { OptionsDocument, PresentationOptionV2 } from 'paintscout'
import { isPresentationNext } from '../../../quote/presentation/is-presentation-next'
import { getPresentationOptions } from './get-presentation-options'

/**
 * The v2 "PresentationNext" presentations available for selection.
 *
 * Optionally filtered by `quoteType` (same `quoteTypes` filter v1 uses via
 * getPresentationOptions) and drops the v1 default presentation that
 * getPresentationOptions always injects, keeping only docs that actually live in
 * `options.presentationOptionsV2`. Explicitly-inactive docs are already excluded
 * by getPresentationOptions.
 */
export function getPresentationNextOptions(args: {
  options: OptionsDocument
  quoteType?: string
}): PresentationOptionV2[] {
  const { options, quoteType } = args
  return getPresentationOptions({ options, v2: true, quoteType }).filter((p) =>
    isPresentationNext({ options, presentation: p })
  )
}
